import React, { FC, ReactNode } from 'react';
import { StylableComponentProps } from '@cld/common-definitions';
import { CollapsibleSectionIE11 } from './CollapsibleSectionIE11';
import { CollapsibleSection } from './CollapsibleSection';
import { SpacingType } from './spacing';
import { isIE } from './utils';

export interface SectionProps extends StylableComponentProps {
  /** Title of the section */
  title: ReactNode;
  /** Content to be hidden when `Section` is collapsed */
  children: ReactNode;
  /** State of the collapse when controlled externally */
  open?: boolean;
  /** Optional callback when state of collapse changes */
  onToggle?: (newState: boolean) => void;
  /** Padding for content of the Section */
  horizontalPadding?: SpacingType;
  verticalPadding?: SpacingType;
}

/** Collapsible section component */
export const Section: FC<SectionProps> = (props) => {
  if (isIE) {
    return <CollapsibleSectionIE11 {...props} />;
  }

  return <CollapsibleSection {...props} />;
};
